import axios from "../axiosInstance";
import {
  SyncCompanyFromSalesforceRequest,
  SyncCompanyFromSalesforceResponse,
} from "./types";

export const syncCompanyFromSalesforce = async (
  requestData: SyncCompanyFromSalesforceRequest,
): Promise<SyncCompanyFromSalesforceResponse> => {
  const response = await axios.post<SyncCompanyFromSalesforceResponse>(
    `/api/private/companies/sync-from-salesforce`,
    requestData,
  );
  return response.data;
};
